export class RedSocial {
  nombreRedSocial:string;
  linkRedSocial:string;
  logo:string;
}



// WEBPACK FOOTER //
// ./src/models/redsocial.model.ts